import React from 'react';
//material
import {Card, CardContent, withStyles, Divider} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';

//styles
import styles from './member-card-styles';

//components
import Avatar from '../../avatar';
import RichTextEditorWrapper from '../../rich-text-editor-wrapper';

const MemberCardView = (props) => {
  const {classes, isLoading, member} = props;

  return (
    <Card>
      <CardContent className={classes.cardContent}>
        {
          !isLoading  ?
            <Avatar
              size={150}
              className={classes.avatar}
              alt={'Avatar'}
              src={member.photoUrl}/> :
            <Skeleton className={classes.avatar} variant={'circle'} height={150} width={150}/>
        }

        <div className={classes.textContainer}>
          {
            isLoading ?
              <Skeleton height={40} width={'60%'} /> :
              <div className={classes.name}>
                { member.firstName + ' ' + member.lastName }
              </div>
          }

          {
            isLoading ?
              <Skeleton height={22} width={'40%'}/> :
              <div className={classes.subheader}>
                {member.companyName}
              </div>
          }

          {
            isLoading ?
              <Skeleton height={22} width={'20%'}/> :
              <div className={classes.subheader}>
                {member.isOfficialHandicap  ? ('HCP Index: ' + member.handicapIndex) : ('Handicap: ' + member.handicap)}
              </div>
          }
        </div>

        <Divider className={classes.divider} />

        {
          isLoading ?
            <>
              <Skeleton height={30} width={'100%'} />
              <Skeleton height={30} width={'100%'} />
              <Skeleton height={30} width={'40%'} />
            </> :
            <RichTextEditorWrapper
              displayEdit={member.isCurrentUser}
              text={member.profileDescription}
              emptytext={`${member.firstName} has not set their profile about information`}
              emitText={(text) => props.updateDescription(text)}/>
        }
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (MemberCardView);
